import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "icon"
}
const _hoisted_2 = { class: "title" }



export default /*@__PURE__*/_defineComponent({
  __name: 'routerButton',
  props: ["title", "color", "icon", "width", "height"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "card",
    style: _normalizeStyle({ width: __props.width + 'px', height: __props.height + 'px', background: __props.color })
  }, [
    (__props.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.icon), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1)
  ], 4))
}
}

})